import LandingHero from "./components/LandingHero";
import LatestProjects from "./components/LatestProjects";
import LandingExperience from "./components/LandingExperience";
import LandingEducation from "./components/LandingEducation";

const LandingPage = () => {
    return (
        <>
            <LandingHero />
            <LatestProjects />
            <LandingExperience />
            <LandingEducation />
        </>
    )
}

export default LandingPage;
